import { createAction } from 'redux-act';
/* createKra action */
const createKraRequest = createAction('CREATE_KRA_REQUEST', data => data);
const createKraSuccess = createAction('CREATE_KRA_SUCCESS', data => data);
const createKraError = createAction('CREATE_KRA_ERROR');

/* get Kra Details action */
const getKraDetailsRequest = createAction('GET_KRA_DETAILS_REQUEST', data => data);
const getKraDetailsSuccess = createAction('GET_KRA_DETAILS_SUCCESS', data => data);
const getKraDetailsError = createAction('GET_KRA_DETAILS_ERROR');

/* get Kra Details action */
const getAllKraDetailsDataRequest = createAction('GET_ALL_KRA_DETAILS_DATA_REQUEST', data => data);
const getAllKraDetailsDataSuccess = createAction('GET_ALL_KRA_DETAILS_DATA_SUCCESS', data => data);
const getAllKraDetailsDataError = createAction('GET_ALL_KRA_DETAILS_DATA_ERROR');

/*update Kra Detail action */
const updateKraDetailRequest = createAction('UPDATE_KRA_DETAIL_REQUEST', data => data);
const updateKraDetailSuccess = createAction('UPDATE_KRA_DETAIL_SUCCESS', data => data);
const updateKraDetailError = createAction('UPDATE_KRA_DETAIL_ERROR');

/* delete Kra Detail action */
const deleteKraDetailRequest = createAction('DELETE_KRA_DETAIL_REQUEST', data => data);
const deleteKraDetailSuccess = createAction('DELETE_KRA_DETAIL_SUCCESS', data => data);
const deleteKraDetailError = createAction('DELETE_KRA_DETAIL_ERROR');

/* create Kra Parameter action */
const createKraParameterRequest = createAction('CREATE_KRA_PARAMETER_REQUEST', data => data);
const createKraParameterSuccess = createAction('CREATE_KRA_PARAMETER_SUCCESS', data => data);
const createKraParameterError = createAction('CREATE_KRA_PARAMETER_ERROR');

/* get Kra Parameter action */
const getKraParameterRequest = createAction('GET_KRA_PARAMETER_REQUEST', data => data);
const getKraParameterSuccess = createAction('GET_KRA_PARAMETER_SUCCESS', data => data);
const getKraParameterError = createAction('GET_KRA_PARAMETER_ERROR');

/* get Kra Parameter action */
const getAllKraParameterDataRequest = createAction('GET_ALL_KRA_PARAMETER_DATA_REQUEST', data => data);
const getAllKraParameterDataSuccess = createAction('GET_ALL_KRA_PARAMETER_DATA_SUCCESS', data => data);
const getAllKraParameterDataError = createAction('GET_ALL_KRA_PARAMETER_DATA_ERROR');

/* update Kra Parameter action*/
const updateKraParameterRequest = createAction('UPDATE_KRA_PARAMETER_REQUEST', data => data);
const updateKraParameterSuccess = createAction('UPDATE_KRA_PARAMETER_SUCCESS', data => data);
const updateKraParameterError = createAction('UPDATE_KRA_PARAMETER_ERROR');

/* delete Kra Parameter list */
const deleteKraParameterRequest = createAction('DELETE_KRA_PARAMETER_REQUEST', data => data);
const deleteKraParameterSuccess = createAction('DELETE_KRA_PARAMETER_SUCCESS', data => data);
const deleteKraParameterError = createAction('DELETE_KRA_PARAMETER_ERROR');

/* create KPi Details action */
const createKPiDetailsRequest = createAction('CREATE_KPI_DETAILS_REQUEST', data => data);
const createKPiDetailsSuccess = createAction('CREATE_KPI_DETAILS_SUCCESS', data => data);
const createKPiDetailsError = createAction('CREATE_KPI_DETAILS_ERROR');

/* get Kpi Details action */
const getKpiDetailsRequest = createAction('GET_KPI_DETAILS_REQUEST', data => data);
const getKpiDetailsSuccess = createAction('GET_KPI_DETAILS_SUCCESS', data => data);
const getKpiDetailsError = createAction('GET_KPI_DETAILS_ERROR');

/* get Kpi Details action */
const getAllKpiDetailsDataRequest = createAction('GET_ALL_KPI_DETAILS_DATA_REQUEST', data => data);
const getAllKpiDetailsDataSuccess = createAction('GET_ALL_KPI_DETAILS_DATA_SUCCESS', data => data);
const getAllKpiDetailsDataError = createAction('GET_ALL_KPI_DETAILS_DATA_ERROR');

/* update Kpi Details action */
const updateKpiDetailRequest = createAction('UPDATE_KPI_DETAIL_REQUEST', data => data);
const updateKpiDetailSuccess = createAction('UPDATE_KPI_DETAIL_SUCCESS', data => data);
const updateKpiDetailError = createAction('UPDATE_KPI_DETAIL_ERROR');

/* deleteKpiDetail action */
const deleteKpiDetailRequest = createAction('DELETE_KPI_DETAIL_REQUEST', data => data);
const deleteKpiDetailSuccess = createAction('DELETE_KPI_DETAIL_SUCCESS', data => data);
const deleteKpiDetailError = createAction('DELETE_KPI_DETAIL_ERROR');

/* create KPi Details action */
const createKraRatingTypeForDepartmentRequest = createAction('CREATE_KPA_RATING_TYPE_FOR_DEPARTMENT_REQUEST', data => data);
const createKraRatingTypeForDepartmentSuccess = createAction('CREATE_KPA_RATING_TYPE_FOR_DEPARTMENT_SUCCESS', data => data);
const createKraRatingTypeForDepartmentError = createAction('CREATE_KPA_RATING_TYPE_FOR_DEPARTMENT_ERROR');

/* get Kpi Details action */
const getKraRatingTypeForDepartmentRequest = createAction('GET_KRA_RATING_TYPE_FOR_DEPARTMENT_REQUEST', data => data);
const getKraRatingTypeForDepartmentSuccess = createAction('GET_KRA_RATING_TYPE_FOR_DEPARTMENT_SUCCESS', data => data);
const getKraRatingTypeForDepartmentError = createAction('GET_KRA_RATING_TYPE_FOR_DEPARTMENT_ERROR');

/* get Kpi Details action */
const getAllKraRatingTypeForDepartmentRequest = createAction('GET_ALL_KRA_RATING_TYPE_FOR_DEPARTMENT_REQUEST', data => data);
const getAllKraRatingTypeForDepartmentSuccess = createAction('GET_ALL_KRA_RATING_TYPE_FOR_DEPARTMENT_SUCCESS', data => data);
const getAllKraRatingTypeForDepartmentError = createAction('GET_ALL_KRA_RATING_TYPE_FOR_DEPARTMENT_ERROR');

/* update Kpi Details action */
const updateKraRatingTypeDepartmentRequest = createAction('UPDATE_KRA_RATING_TYPE_FOR_DEPARTMENT_REQUEST', data => data);
const updateKraRatingTypeDepartmentSuccess = createAction('UPDATE_KRA_RATING_TYPE_FOR_DEPARTMENT_SUCCESS', data => data);
const updateKraRatingTypeDepartmentError = createAction('UPDATE_KRA_RATING_TYPE_FOR_DEPARTMENT_ERROR');

/* deleteKpiDetail action */
const deleteKraRatingTypeForDepartmentRequest = createAction('DELETE_KRA_RATING_TYPE_FOR_DEPARTMENT_REQUEST', data => data);
const deleteKraRatingTypeForDepartmentSuccess = createAction('DELETE_KRA_RATING_TYPE_FOR_DEPARTMENT_SUCCESS', data => data);
const deleteKraRatingTypeForDepartmentError = createAction('DELETE_KRA_RATING_TYPE_FOR_DEPARTMENT_ERROR');

/* create Self Permission action */
const createSelfRatingPermissionRequest = createAction('CREATE_SELF_RATING_PERMISSION_REQUEST', data => data);
const createSelfRatingPermissionSuccess = createAction('CREATE_SELF_RATING_PERMISSION_SUCCESS', data => data);
const createSelfRatingPermissionError = createAction('CREATE_SELF_RATING_PERMISSION_ERROR');

/* get Self Permission action */
const getSelfRatingPermissionRequest = createAction('GET_SELF_RATING_PERMISSION_REQUEST', data => data);
const getSelfRatingPermissionSuccess = createAction('GET_SELF_RATING_PERMISSION_SUCCESS', data => data);
const getSelfRatingPermissionError = createAction('GET_SELF_RATING_PERMISSION_ERROR');

/* get All Self Permission action */
const getAllSelfRatingPermissionRequest = createAction('GET_ALL_SELF_RATING_PERMISSION_REQUEST', data => data);
const getAllSelfRatingPermissionSuccess = createAction('GET_ALL_SELF_RATING_PERMISSION_SUCCESS', data => data);
const getAllSelfRatingPermissionError = createAction('GET_ALL_SELF_RATING_PERMISSION_ERROR');

/* update Self Permission action */
const updateSelfRatingPermissionRequest = createAction('UPDATE_SELF_RATING_PERMISSION_REQUEST', data => data);
const updateSelfRatingPermissionSuccess = createAction('UPDATE_SELF_RATING_PERMISSION_SUCCESS', data => data);
const updateSelfRatingPermissionError = createAction('UPDATE_SELF_RATING_PERMISSION_ERROR');

/* delete Self Permission action */
const deleteSelfRatingPermissionRequest = createAction('DELETE_SELF_RATING_PERMISSION_REQUEST', data => data);
const deleteSelfRatingPermissionSuccess = createAction('DELETE_SELF_RATING_PERMISSION_SUCCESS', data => data);
const deleteSelfRatingPermissionError = createAction('DELETE_SELF_RATING_PERMISSION_ERROR');

/* Assign Kra action */
const assignKraRequest = createAction('CREATE_ASSIGN_KRA_REQUEST', data => data);
const assignKraSuccess = createAction('CREATE_ASSIGN_KRA_SUCCESS', data => data);
const assignKraError = createAction('CREATE_ASSIGN_KRA_ERROR');

/* get assign Kra action */
const getAssignKraRequest = createAction('GET_ASSIGN_KRA_REQUEST', data => data);
const getAssignKraSuccess = createAction('GET_ASSIGN_KRA_SUCCESS', data => data);
const getAssignKraError = createAction('GET_ASSIGN_KRA_ERROR');

/* get all assign Kra action */
const getAllAssignKraRequest = createAction('GET_ALL_ASSIGN_KRA_REQUEST', data => data);
const getAllAssignKraSuccess = createAction('GET_ALL_ASSIGN_KRA_SUCCESS', data => data);
const getAllAssignKraError = createAction('GET_ALL_ASSIGN_KRA_ERROR');

/* update assign Kra action */
const updateAssignKraRequest = createAction('UPDATE_ASSIGN_KRA_REQUEST', data => data);
const updateAssignKraSuccess = createAction('UPDATE_ASSIGN_KRA_SUCCESS', data => data);
const updateAssignKraError = createAction('UPDATE_ASSIGN_KRA_ERROR');

/* delete assign Kra action */
const deleteAssignKraRequest = createAction('DELETE_ASSIGN_KRA_REQUEST', data => data);
const deleteAssignKraSuccess = createAction('DELETE_ASSIGN_KRA_SUCCESS', data => data);
const deleteAssignKraError = createAction('DELETE_ASSIGN_KRA_ERROR');

/* get Employee By Kra  action */
const getEmployeeByKraRequest = createAction('GET_EMPLOYEE_BY_KRA_REQUEST', data => data);
const getEmployeeByKraSuccess = createAction('GET_EMPLOYEE_BY_KRA_SUCCESS', data => data);
const getEmployeeByKraError = createAction('GET_EMPLOYEE_BY_KRA_ERROR');

/* give Rating  action */
const giveRatingRequest = createAction('GIVE_RATING_REQUEST', data => data);
const giveRatingSuccess = createAction('GIVE_RATING_SUCCESS', data => data);
const giveRatingError = createAction('GIVE_RATING_ERROR');

/*get Given Rating  action */
const getGivenRatingRequest = createAction('GET_GIVEN_RATING_REQUEST', data => data);
const getGivenRatingSuccess = createAction('GET_GIVEN_RATING_SUCCESS', data => data);
const getGivenRatingError = createAction('GET_GIVEN_RATING_ERROR');


/* update Rating duration  action */
const updateRatingDurationRequest = createAction('UPDATE_RATING_DURATION_REQUEST', data => data);
const updateRatingDurationSuccess = createAction('UPDATE_RATING_DURATION_SUCCESS', data => data);
const updateRatingDurationError = createAction('UPDATE_RATING_DURATION_ERROR');

/* Get Kra Details By Employee  action */
const getKraDetailsByEmployeeRequest = createAction('GET_KRA_DETAILS_BY_EMPLOYEE_REQUEST', data => data);
const getKraDetailsByEmployeeSuccess = createAction('GET_KRA_DETAILS_BY_EMPLOYEE_SUCCESS', data => data);
const getKraDetailsByEmployeeError = createAction('GET_KRA_DETAILS_BY_EMPLOYEE_ERROR');

/* Get Rating Wise Employee  action */
const getRatingWiseEmployeeRequest = createAction('GET_RATING_WISE_EMPLOYEE_REQUEST', data => data);
const getRatingWiseEmployeeSuccess = createAction('GET_RATING_WISE_EMPLOYEE_SUCCESS', data => data);
const getRatingWiseEmployeeError = createAction('GET_RATING_WISE_EMPLOYEE_ERROR');

/* Get Average Rating  action */
const getAverageRatingRequest = createAction('GET_AVERAGE_RATING_REQUEST', data => data);
const getAverageRatingSuccess = createAction('GET_AVERAGE_RATING_SUCCESS', data => data);
const getAverageRatingError = createAction('GET_AVERAGE_RATING_ERROR');

/* Selected Kra Detail action*/
const selectedKraDetailData = createAction('HANDLE_SELECTED_KRA_DETAIL_DATA_STORE', data => data);

/* clear existing PMS action */
const handleClearPMSStore = createAction('HANDLE_CLEAR_PMS_STORE', data => data);

export default {
    createKraRequest,
    createKraSuccess,
    createKraError,

    getKraDetailsRequest,
    getKraDetailsSuccess,
    getKraDetailsError,

    getAllKraDetailsDataRequest,
    getAllKraDetailsDataSuccess,
    getAllKraDetailsDataError,

    updateKraDetailRequest,
    updateKraDetailSuccess,
    updateKraDetailError,

    deleteKraDetailRequest,
    deleteKraDetailSuccess,
    deleteKraDetailError,

    createKraParameterRequest,
    createKraParameterSuccess,
    createKraParameterError,

    getKraParameterRequest,
    getKraParameterSuccess,
    getKraParameterError,

    getAllKraParameterDataRequest,
    getAllKraParameterDataSuccess,
    getAllKraParameterDataError,


    updateKraParameterRequest,
    updateKraParameterSuccess,
    updateKraParameterError,

    deleteKraParameterRequest,
    deleteKraParameterSuccess,
    deleteKraParameterError,

    createKPiDetailsRequest,
    createKPiDetailsSuccess,
    createKPiDetailsError,

    getKpiDetailsRequest,
    getKpiDetailsSuccess,
    getKpiDetailsError,

    getAllKpiDetailsDataRequest,
    getAllKpiDetailsDataSuccess,
    getAllKpiDetailsDataError,

    updateKpiDetailRequest,
    updateKpiDetailSuccess,
    updateKpiDetailError,

    deleteKpiDetailRequest,
    deleteKpiDetailSuccess,
    deleteKpiDetailError,

    createKraRatingTypeForDepartmentRequest,
    createKraRatingTypeForDepartmentSuccess,
    createKraRatingTypeForDepartmentError,

    getKraRatingTypeForDepartmentRequest,
    getKraRatingTypeForDepartmentSuccess,
    getKraRatingTypeForDepartmentError,

    getAllKraRatingTypeForDepartmentRequest,
    getAllKraRatingTypeForDepartmentSuccess,
    getAllKraRatingTypeForDepartmentError,

    updateKraRatingTypeDepartmentRequest,
    updateKraRatingTypeDepartmentSuccess,
    updateKraRatingTypeDepartmentError,

    deleteKraRatingTypeForDepartmentRequest,
    deleteKraRatingTypeForDepartmentSuccess,
    deleteKraRatingTypeForDepartmentError,

    createSelfRatingPermissionRequest,
    createSelfRatingPermissionSuccess,
    createSelfRatingPermissionError,

    getSelfRatingPermissionRequest,
    getSelfRatingPermissionSuccess,
    getSelfRatingPermissionError,

    getAllSelfRatingPermissionRequest,
    getAllSelfRatingPermissionSuccess,
    getAllSelfRatingPermissionError,

    updateSelfRatingPermissionRequest,
    updateSelfRatingPermissionSuccess,
    updateSelfRatingPermissionError,

    deleteSelfRatingPermissionRequest,
    deleteSelfRatingPermissionSuccess,
    deleteSelfRatingPermissionError,

    assignKraRequest,
    assignKraSuccess,
    assignKraError,

    getAssignKraRequest,
    getAssignKraSuccess,
    getAssignKraError,

    getAllAssignKraRequest,
    getAllAssignKraSuccess,
    getAllAssignKraError,

    updateAssignKraRequest,
    updateAssignKraSuccess,
    updateAssignKraError,

    deleteAssignKraRequest,
    deleteAssignKraSuccess,
    deleteAssignKraError,

    getEmployeeByKraRequest,
    getEmployeeByKraSuccess,
    getEmployeeByKraError,

    giveRatingRequest,
    giveRatingSuccess,
    giveRatingError,

    getGivenRatingRequest,
    getGivenRatingSuccess,
    getGivenRatingError,

    updateRatingDurationRequest,
    updateRatingDurationSuccess,
    updateRatingDurationError,

    getKraDetailsByEmployeeRequest,
    getKraDetailsByEmployeeSuccess,
    getKraDetailsByEmployeeError,

    getAverageRatingRequest,
    getAverageRatingSuccess,
    getAverageRatingError,

    getRatingWiseEmployeeRequest,
    getRatingWiseEmployeeSuccess,
    getRatingWiseEmployeeError,


    selectedKraDetailData,
    handleClearPMSStore,

}